
import React, { useEffect } from 'react';
import TableView from '../Table/Table';
import { tableHeadings } from '../../../utils/constants';
import { connect } from "react-redux";
import { setModified } from '../../../redux/actions/UploadActions';
import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';



const KeysTable = (props) => {
    useEffect(() => {

    }, [])

    let downloadData = []

    props.UPLOADREDUCER.keysResult && props.UPLOADREDUCER.keysResult.forEach(item => {
        downloadData.push(item)
    })

    return (
        <Panel>
            <PanelHeader>
                Key Results
                    <button className='btn btn-primary d-block w-30 btn-lg h-9px fs-11px' > save
                        {/* <CSVLink data={downloadData} headers={headings} filename={'Keys Result'}>Save</CSVLink> */}
                    </button>
            </PanelHeader>
            {/* <div className='button-section'>
                <div className='back-arrow' onClick={handleBack}>
                    <ArrowBackIcon />
                    <span>Back</span>
                </div>
            </div> */}
            <PanelBody>
                <TableView height={600} headings={tableHeadings['keys']} data={props.UPLOADREDUCER.keysResult} />
            </PanelBody>
        </Panel>
    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    setModified
}


export default connect(mapStateToProps, mapDispatchToProps)(KeysTable);